import type { SVGProps } from 'react';

export interface AsterMarkProps extends SVGProps<SVGSVGElement> {
  readonly compact?: boolean;
}

/**
 * The Aster emblem is deliberately code-native: five market-depth ladders converge
 * into a star while a price trace crosses the centre. It scales cleanly from the
 * cinematic lock-up to the 24 px terminal mark.
 */
export function AsterMark({ compact = false, className, ...props }: AsterMarkProps) {
  return (
    <svg
      viewBox={compact ? '0 0 96 96' : '0 0 420 96'}
      role="img"
      aria-label="Head of Trading"
      className={className}
      {...props}
    >
      <defs>
        <linearGradient id="aster-metal" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#f5d59d" />
          <stop offset="0.48" stopColor="#bc8245" />
          <stop offset="1" stopColor="#76502e" />
        </linearGradient>
        <linearGradient id="aster-blue" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#1463df" />
          <stop offset="1" stopColor="#55b8ff" />
        </linearGradient>
        <filter id="aster-glow" x="-30%" y="-30%" width="160%" height="160%">
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feMerge><feMergeNode in="blur" /><feMergeNode in="SourceGraphic" /></feMerge>
        </filter>
      </defs>
      <g transform="translate(6 6)">
        <path d="M42 0 50 28 80 16 58 40 84 56 53 55 56 86 42 59 28 86 31 55 0 56 26 40 4 16 34 28Z" fill="#081529" stroke="url(#aster-metal)" strokeWidth="1.3" />
        <path d="M42 7 48 32 73 23 54 41 77 55 50 51 54 77 42 54 30 77 34 51 7 55 30 41 11 23 36 32Z" fill="none" stroke="url(#aster-blue)" strokeWidth="2" filter="url(#aster-glow)" />
        <path d="M17 46h12l4-8 5 14 5-22 5 16h19" fill="none" stroke="#f0c786" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <g stroke="#4c8eea" strokeWidth="1" opacity=".7">
          <path d="M42 11v14M42 61v14M10 55h14M60 55h14M19 27l11 9M54 36l11-9" />
          <path d="M34 18h16M27 23h30M22 68h12M50 68h12" opacity=".45" />
        </g>
        <circle cx="42" cy="43" r="3.5" fill="#f4ce91" />
      </g>
      {!compact && (
        <g transform="translate(108 22)">
          <text x="0" y="25" fill="#eef4ff" fontFamily="Inter, Arial, sans-serif" fontSize="27" fontWeight="670" letterSpacing="2.5">HEAD OF TRADING</text>
          <path d="M1 35h272" stroke="#345b8f" strokeWidth="1" />
        </g>
      )}
    </svg>
  );
}
